import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export const PROFILE_TABS = {
  PERFORMANCE: "performanceMetrics",
  SOP_STATUS: "sopStatus",
  KEY_INFO: "keyInformation",
  NOTES: "notes",
} as const;

export type ProfileTabIds = (typeof PROFILE_TABS)[keyof typeof PROFILE_TABS];

interface DownlineProfileState {
  affAbo: string;
  selectedKpis: string[];
  availableKpis: string[];
  viewMode: "graphView" | "tableView" | "";
  activeTab: ProfileTabIds;
  history: string[];
  isApplyingKpis: boolean;
}
export const initialState: DownlineProfileState = {
  affAbo: "",
  selectedKpis: [],
  availableKpis: [],
  viewMode: "graphView",
  activeTab: "performanceMetrics",
  history: [],
  isApplyingKpis: false,
};
const { actions, reducer } = createSlice({
  name: "aboDownlineProfile",
  initialState,
  reducers: {
    setSelectedDownlineProfile: (state, action: PayloadAction<string>) => {
      state.affAbo = action.payload;
    },
    setSelectedKpis: (state, action: PayloadAction<string[]>) => {
      state.selectedKpis = action.payload;
    },
    setAvailableKpis: (state, action: PayloadAction<string[]>) => {
      state.availableKpis = action.payload;
    },
    setViewMode: (state, action: PayloadAction<"graphView" | "tableView">) => {
      state.viewMode = action.payload;
    },
    setActiveTab: (state, action: PayloadAction<ProfileTabIds>) => {
      state.activeTab = action.payload;
    },
    setIsApplyingKpis: (state, action: PayloadAction<boolean>) => {
      state.isApplyingKpis = action.payload;
    },
    resetHistory: (state, action: PayloadAction<string>) => {
      const [aff, abo] = action.payload?.split("-") ?? [];
      const normalized = aff && abo ? `${aff.padStart(3, "0")}-${abo}` : action.payload;

      state.history = normalized ? [normalized] : [];
      state.affAbo = normalized || state.affAbo;
    },
    pushToHistory: (state, action: PayloadAction<string>) => {
      if (state.history.includes(action.payload)) return;
      state.history.push(action.payload);
      state.affAbo = action.payload;
    },
    goBackInHistory: (state) => {
      if (state.history.length > 0) state.history.pop();
      state.affAbo = state.history.at(-1) ?? state.affAbo;
    },
  },
});

export const {
  setSelectedDownlineProfile,
  setSelectedKpis,
  setAvailableKpis,
  setViewMode,
  setIsApplyingKpis,
  setActiveTab,
  resetHistory,
  pushToHistory,
  goBackInHistory,
} = actions;

export default reducer;
